/* eslint-disable react-hooks/exhaustive-deps */
import React, { forwardRef, Fragment, useEffect, useRef, useState } from "react";
// import { styled } from '@mui/material/styles';
import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import { Button } from '@mui/material';
import { useReactToPrint } from "react-to-print";
import { useNavigate } from 'react-router-dom'
import { showGPA } from '../components/functions/education'
import axios from 'axios';
import Persattrscore from '../components/Persattrscore'
import { toast} from 'react-toastify'


  function getGPA(params) {
    // console.log('get: ',params)
    const gradeAll = []
    let sum = 0
    for (let i = 1; i < 8; i++) {
      gradeAll.push(params[`grade_${i}`])
    }
    const grade = gradeAll.filter((item) => item !== null)
    for (let i = 0; i < grade.length; i++) {
      sum += showGPA(grade[i])
    }
    const sumGPA2 = sum / grade.length
    const GPA = Math.floor(sumGPA2 * 100) / 100
    // console.log(GPA)
    if (isNaN(GPA)) {
      return '-'
    } else {
      return GPA.toFixed(2)
    }
  }

/*------------- Function Component to be called by ToPrintPageInsertScore -----------*/
const ComponentToPrint = forwardRef((props, ref) => {
    const { dataToPrint } = props;
    const [ rows, setRows ] = useState([]);
    const coursenameref = useRef(localStorage.getItem('CourseName')); 
    const token = JSON.parse(localStorage.getItem('token'))
    const navigate = useNavigate()
    const checkPage = 1

    useEffect(()=>{
        // if (submit) {
        
        if(dataToPrint.coursegrp !== '' && dataToPrint.seminar !== ''){
            fetchdata();
            // setSubmit(false);
        }
    // }
    },[props])

    const fetchdata = async () => {
        await axios.get(process.env.REACT_APP_API + `/result/course/${dataToPrint.coursegrp}/seminar/${dataToPrint.seminar}/${dataToPrint.courseid}?token=${token}`)
        .then(list => {
            setRows(list.data.data1);
            // console.log("data", list.data)
        })
        .catch(err => {
            if(err.response.status === 400) {
                toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
                localStorage.clear();
                navigate('/')
              } else {
                console.log("err: ", err.response.data)
              }
            console.log('ToPrintPageInsertScore failed >>> err : ', err);
        });
    }

    const sortStudent = rows.slice().sort((a, b) => a.Seminar - b.Seminar); 
    
    return (
        <div ref={ref}>
        <Table
            sx={{
                [`& .${ tableCellClasses.root }`]: {
                    border: 'none'
                }
            }} 
        >
            <TableHead>
                <TableRow>
                    <TableCell colSpan={2} align='center'>
                        <div style={{ fontSize: 24, fontWeight: 'bold' }}>
                            รายงานผลการศึกษาสรุปรวม
                        </div>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell colSpan={2} align='center'>
                        <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                            หลักสูตร&ensp;{ coursenameref.current }
                        </div>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align='center'>
                        <strong>รุ่นที่</strong>&ensp;{ dataToPrint.coursegrp }  
                    </TableCell>
                    <TableCell align='center'>
                        <strong>สัมมนาที่</strong>&ensp;
                        { dataToPrint.seminar === 0 ? '--' : dataToPrint.seminar }  
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
        {/*------------------ สรุปชั่วโมงการศึกษา -----------------*/}
        <hr/>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell colSpan={15} align='center'>
                        <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                            ผลการศึกษาสรุปรวม
                        </div>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell align='center' sx={{ width: 20}}>
                        <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            ลำดับ
                        </div>
                    </TableCell>
                    <TableCell align='center'>
                        <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            เลขประจำตัว นทน.
                        </div>
                    </TableCell>
                    <TableCell align='center' sx={{ width: 50}}>
                        <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            ยศ-ชื่อ-สกุล
                        </div>
                    </TableCell>
                    <TableCell align='center'>
                        <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            เกรดเฉลี่ยสะสม/GPA
                        </div>
                    </TableCell>
                    <TableCell align='center'>
                        <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            คะแนนเฉลี่ยคุณลักษณะส่วนบุคคล
                        </div>
                    </TableCell >
                    <TableCell align='center'>
                        <div style={{ fontSize: 12, fontWeight: 'bold' }}>
                            สถานะ
                        </div>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    sortStudent.map((e, i) => {
                        return (
                            <TableRow key={i}>
                                <TableCell align='center'>
                                    <div style={{ fontSize: 12 }}>
                                        {/* { e.id } */}
                                        { i+1 }
                                    </div>
                                </TableCell>
                                <TableCell align='center'>
                                    <div style={{ fontSize: 12 }}>
                                        { e.StudentId }
                                    </div>
                                </TableCell>
                                <TableCell align='left'>
                                    <div style={{ fontSize: 12, whiteSpace: 'nowrap' }}>
                                        { e.Rank} { e.PersFname } {e.PersLname}
                                    </div>
                                </TableCell>
                                <TableCell align='center'>
                                    <div style={{ fontSize: 12 }}>
                                        {/* { e.period } */}
                                        { getGPA(e) }
                                    </div>
                                </TableCell>
                                <TableCell align='center'>
                                    <div style={{ fontSize: 12 }}>
                                        {/* {  */}
                                        <Persattrscore
                                        courseGrp={e.CourseGrp}
                                        courseid={e.cutstring}
                                        persid={e.PerId}
                                        checkPage={checkPage}
                                        // submit={submit}
                                      /> 
                                        {/* } */}
                                    </div>
                                </TableCell>
                                <TableCell align='center'>
                                    {
                                        Number(getGPA(e)) >= 2.00 || e.Grade === "P" ?
                                        <div style={{ fontSize: 12, color: '#018822' }}>
                                            ผ่าน
                                        </div> :
                                        <div style={{ fontSize: 12, color: '#A50000' }}>
                                            ไม่ผ่าน
                                        </div>
                                    }
                                </TableCell>
                            </TableRow>
                        );
                    })      
                }
                
            </TableBody>
        </Table>
     </div>
    ); //end of return
});

const ToPrintPageSummarize = (props) => {
    const { dataToPrint } = props;
    const componentRef = useRef();

    const marginTop = '1cm';
    const marginRight = '0.5cm';
    const marginBottom = '1cm';
    const marginLeft = '0.5cm';

    const getPageMargin = () => {
        return (`
            @page {
                size: A4 landscape;
                margin: ${marginTop} ${marginRight} ${marginBottom} ${marginLeft} !important;
            }
        `);
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        pageStyle: getPageMargin() 
    });
    
    /*------- updated on 23.09.2022 -> change button, color and fontweght ----*/
    return(
        <Fragment>
            <div style={{ display: 'none' }}>
                <ComponentToPrint ref={ componentRef } dataToPrint={ dataToPrint }/>
            </div>
            {/*<IconButton onClick={ 
                handlePrint
            }>
                <LocalPrintshopIcon sx={{ color: '#3A9CFE' }} />
            </IconButton>*/}
            <Button 
                variant={'contained'} 
                startIcon={ <LocalPrintshopIcon/> }
                sx={{
                    minWidth: 100, 
                    minHeight: 55, 
                    m:1,
                    fontFamily: 'THSarabunNew',
                    fontWeight: 'bold',
                    fontSize: 16,
                }}
                onClick={ 
                    handlePrint
                }
            >
                พิมพ์
            </Button>
        </Fragment>

    );
}

export default ToPrintPageSummarize